import React, { Component } from 'react'
import { Tab } from 'semantic-ui-react'

import CodeMirror from 'react-codemirror'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/scroll/annotatescrollbar'
import 'codemirror/addon/search/search'
import 'codemirror/addon/search/searchcursor'
import 'codemirror/addon/search/jump-to-line'
import 'codemirror/addon/search/matchesonscrollbar'

import fetch from 'isomorphic-fetch'

import { Article } from './Article'

class ArticlePreview extends Component {

  state = {}

  async componentDidMount () {
    await this.fetch_article_content()
  }
    
  async fetch_article_content () {
    const { preview_url } = this.props
    if (preview_url) {
      await this._fetch_article_content(preview_url)
    }
  }

  async _fetch_article_content (preview_url) {
    let article
    try {
      await this.setStateAsync({ loading: true })
      const resp = await fetch(preview_url, {method: 'get'})
      article = await resp.json()
    } catch(e) {
      console.error(e)
      article = null 
    }
    await this.setStateAsync({ article: article, loading: false })
  }

  setStateAsync (state) {
    return new Promise((resolve) => {
      this.setState(state, resolve)
    })
  }

  render () {
    return (
      <Tab menu={{ secondary: true, pointing: true}}
        panes={[ {
          menuItem: 'Artikel',
          render: () => this.render_article()
          },
          {
            menuItem: 'Metadata',
            render: () => this.render_metadata()
          },
          {
            menuItem: 'JSON',
            render: () => this.render_json() 
          },
        ]}
      />
    )}

   render_article () {
     const { article } = this.state

     const _article = article && { ...article,
                                   content: (article.content || article.content_html_body || article.article_html ) }
     return (
       <Tab.Pane className='ArticlePreview-tab'>
         <div className='ArticlePreview-article-tab-content'>
           <Article topicle={_article || {}} detail_topicle={_article} loading={false} />
         </div>
       </Tab.Pane>
     )
   }

   render_metadata () {
     const { loading } = this.state
     return (
       <Tab.Pane loading={loading} className='ArticlePreview-tab'>
         <div className='ArticlePreview-metadata-tab-content '>
         </div>
       </Tab.Pane>
     )
   }

   render_json () {
     const { preview_url } = this.props
     const { article, loading } = this.state

     const article_src = article ? JSON.stringify(article, null, 2) : ' '

     return (
        <Tab.Pane loading={ loading } className='ArticlePreview-tab'>
          <div className='ArticlePreview-json-tab-content'>
            <CodeMirror {...{value: article_src,
              key: preview_url,
              className: 'codemirror-json',
              options: {
                mode: 'javascript',
                readOnly: true,
                lineWrapping: true,
                lineNumbers: true,
                foldGutter: true,
                lint: true,
                gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
                theme: 'ttcn',
                extraKeys: {
                  'Ctrl-F': function(cm) {
                    cm.execCommand('findPersistentNext')
                  }
                }
              }}} />
          </div>
        </Tab.Pane>
     )
  }
}

export { ArticlePreview }



// WEBPACK FOOTER //
// ./src/probish/ArticlePreview.js